import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../../interfaces/IReduxState";


export const ClassSelectionDataReadSlice = createSlice({
  name: "ClassSelectionDataReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ClassSelectionDataRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successClassSelectionDataRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureClassSelectionDataRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearClassSelectionDataRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  ClassSelectionDataRead,
  successClassSelectionDataRead,
  failureClassSelectionDataRead,
  clearClassSelectionDataRead,
} = ClassSelectionDataReadSlice.actions;

export default ClassSelectionDataReadSlice.reducer;
